import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import { DistributorAuthProvider } from "./context/DistributorAuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
<DistributorAuthProvider>
      <App />
      </DistributorAuthProvider>
    </AuthProvider>
  </React.StrictMode>
);
